import * as Stepbar from './components/Stepbar.css';
import * as Step from './components/Step/Step.css';

export default {
	Stepbar,
	Step
};
